module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usertype-history-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('div', [_c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.notify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.notify.success, 'alert-danger': _vm.notify.danger, 'alert-warning': _vm.notify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _vm._l((_vm.notify.errors), function(error) {
    return _c('p', {
      staticClass: "notify-msg"
    }, [_vm._v(_vm._s(error))])
  })], 2)])]) : _vm._e()])], 1), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v(_vm._s(_vm.$t('User List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Usertype History')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Usertype History')))])]), _c('div', {
    staticClass: "col-sm-3"
  })]), (_vm.loading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('p', [_c('img', {
    staticClass: "img-rounded",
    staticStyle: {
      "width": "auto",
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.userImage
    },
    on: {
      "click": function($event) {
        _vm.onClickImageModalShow(_vm.user)
      }
    }
  })]), _c('h4', [_vm._v(_vm._s(_vm.user.user_name) + "　" + _vm._s(_vm.user.user_firstname)), _c('br'), _vm._v("（" + _vm._s(_vm.user.user_name_furigana) + " " + _vm._s(_vm.user.user_firstname_furigana) + " ）")]), _c('p', {
    staticClass: "profile"
  }, [_vm._v("性別 : " + _vm._s(_vm.user.user_sex)), _c('br'), _vm._v("生年月日 : " + _vm._s(_vm.user.user_birthday_format) + " "), _c('br'), _vm._v("年齢 : " + _vm._s(_vm.user.user_age) + " 歳")])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "row margin-top"
  }), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label text-right"
  }, [_vm._v("役職異動前")]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('span', [_vm._v(_vm._s(_vm.change.user_type_name_before))])])]), _c('div', {
    staticClass: "row margin-top"
  }), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label text-right"
  }, [_vm._v("役職異動後")]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change.user_type_id_after),
      expression: "change.user_type_id_after"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_type_id_after
    },
    on: {
      "change": [function($event) {
        _vm.change.user_type_id_after = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.selectedUserType]
    }
  }, [_c('option'), _vm._l((_vm.usertypes), function(usertype) {
    return _c('option', {
      domProps: {
        "value": usertype.id
      }
    }, [_vm._v(_vm._s(usertype.attributes['user-type-name']))])
  })], 2), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_type_id_after),
      expression: "!validation.user_type_id_after"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※役職者への変更の時、身元保証書・保証人住民票・印鑑登録証明書・保証人確認票 を再度確認下さい。")])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label text-right"
  }, [_vm._v("役職異動日")]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change.change_day),
      expression: "change.change_day"
    }],
    class: {
      required: !_vm.validation.change_day
    },
    attrs: {
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.change.change_day)
    },
    on: {
      "input": function($event) {
        _vm.change.change_day = $event
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.change_day),
      expression: "!validation.change_day"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validation.change_day && !_vm.validation.change_day_range),
      expression: "validation.change_day && !validation.change_day_range"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.date_range')))])], 1)])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onClickSave
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v("保存")])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.onClickCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v("キャンセル")])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37ffa213!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/usertype-history-edit.pug
// module id = 805
// module chunks = 1